import { registerWeapon } from './registry';
import { DEFAULT_CRATER } from '../terrain/crater-shapes';

const GRAVITY_BOMB = registerWeapon({
  id: 'gravity_bomb',
  name: 'Gravity Bomb',
  description: 'Drops like an anvil from apex. The further it falls, the bigger the boom.',
  tier: 'RARE',
  rarity: 'rare',
  projectileRadius: 8,
  projectileSpeed: 0.55,
  color: 0x8844ff,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  // Base stats — scaled up dynamically by fall distance in onTick
  damage: 15,
  blastRadius: 50,
  knockbackMult: 0.04,
  knockbackRadius: 1.2,
  shakeIntensity: 4.0,
  particleScale: 0.5,
  craterShape: DEFAULT_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.5,
  onTick(proj, _state, _fx) {
    const prevVy = proj.behaviorState.prevVy ?? proj.vy;
    proj.behaviorState.prevVy = proj.vy;

    // Detect apex: vy sign flip (was going up, now going down)
    if (prevVy < 0 && proj.vy >= 0 && !proj.behaviorState.apexDetected) {
      proj.behaviorState.apexDetected = 1;
      proj.behaviorState.apexY = proj.y;
      proj.behaviorState.hoverFrames = 0;
      proj.vy = 0;
      proj.vx = 0; // dead stop — drops straight down
      proj.ignoreWind = true; // anvil doesn't drift
      // Create per-projectile weapon copy so we can mutate stats
      proj.weapon = { ...proj.weapon };
    }

    // Hover briefly for drama, then drop
    if (proj.behaviorState.apexDetected) {
      proj.behaviorState.hoverFrames = (proj.behaviorState.hoverFrames || 0) + 1;

      if (proj.behaviorState.hoverFrames <= 8) {
        // Brief hang — freeze in place
        proj.vy = 0;
        proj.vx = 0;
        return null;
      }

      // Falling — heavy gravity (anvil drop)
      proj.weapon.gravity = 0.35;

      // Scale stats by fall distance (0 → 800px maps to 0 → 1)
      const fallDist = Math.max(0, proj.y - proj.behaviorState.apexY);
      const t = Math.min(fallDist / 800, 1);
      proj.weapon.damage = Math.round(15 + t * 50);        // 15 → 65
      proj.weapon.blastRadius = Math.round(50 + t * 130);   // 50 → 180
      proj.weapon.knockbackMult = 0.04 + t * 0.12;          // 0.04 → 0.16
      proj.weapon.particleScale = 0.5 + t * 1.3;            // 0.5 → 1.8
      proj.weapon.shakeIntensity = 4.0 - t * 2.5;           // 4.0 → 1.5 (lower = more shake)

      // Grow the projectile visually as it falls
      proj.radius = 8 + t * 6;  // 8 → 14
    }
    return null;
  },
});
